import {
  AbstractControl,
  FormArray,
  FormControl,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  ValidatorFn,
  Validators
} from '@angular/forms';
import * as _ from 'lodash';

export function setFormControlValue(
  control: AbstractControl,
  value: any | null
) {
  if (value != null && value != undefined) {
    control.setValue(value);
  }
}

export function getDirtyValues(form: UntypedFormGroup): { [key: string]: any } {
  const result: { [key: string]: any } = {};
  _.forIn(form.controls, (currentControl, controlName) => {
    if (!currentControl.dirty) {
      return;
    }

    if (currentControl instanceof UntypedFormGroup) {
      result[controlName] = getDirtyValues(currentControl);
    } else if (currentControl instanceof UntypedFormArray) {
      result[controlName] = getDirtyValuesFromFormArray(currentControl);
    } else if (currentControl instanceof UntypedFormControl) {
      result[controlName] = currentControl.value;
    }
  });

  return result;
}

export function getDirtyValuesFromFormArray(form: UntypedFormArray) {
  const result: any[] = [];
  form.controls.forEach((control) => {
    if (!control.dirty) {
      return;
    }

    if (control instanceof UntypedFormControl) {
      result.push(control.value);
    } else if (control instanceof UntypedFormArray) {
      result.push(getDirtyValuesFromFormArray(control));
    } else if (control instanceof UntypedFormGroup) {
      result.push(getDirtyValues(control));
    }
  });

  return result;
}
